import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Input from '../../components/UI/Input';
import Button from '../../components/UI/Button';
import * as companyService from '../../services/companyService';
import { toast } from 'react-toastify';

export default function CompanyRegister() {
	const navigate = useNavigate();
	const [form, setForm] = useState({ companyName: '', email: '', website: '', industry: '', size: '', password: '', confirm: '', terms: false });
	const [loading, setLoading] = useState(false);

	function onChange(e) {
		const { name, type, checked, value } = e.target;
		setForm((f) => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
	}

	async function onSubmit(e) {
		e.preventDefault();
		if (!form.terms) {
			toast.error('Please accept terms and conditions');
			return;
		}
		if (form.password !== form.confirm) {
			toast.error('Passwords do not match');
			return;
		}
		setLoading(true);
		try {
			await companyService.registerCompany({
				companyName: form.companyName,
				email: form.email,
				website: form.website,
				industry: form.industry,
				size: form.size,
				password: form.password
			});
			toast.success('Registration successful. Please log in.');
			navigate('/company/login');
		} catch (err) {
			toast.error(err?.response?.data?.message || 'Registration failed');
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="min-h-screen flex items-center justify-center bg-blue-50 px-4">
			<div className="w-full max-w-lg bg-white shadow rounded-lg p-6 border border-blue-100">
				<h1 className="text-2xl font-bold text-center text-blue-700">Register Company</h1>
				<form className="mt-6 space-y-4" onSubmit={onSubmit}>
					<Input name="companyName" label="Company Name" value={form.companyName} onChange={onChange} required />
					<Input name="email" label="Email" value={form.email} onChange={onChange} required />
					<Input name="website" label="Website" value={form.website} onChange={onChange} />
					<div className="grid grid-cols-1 md:grid-cols-2 gap-3">
						<div>
							<label className="block text-sm font-medium text-gray-700 mb-1">Industry</label>
							<select name="industry" className="w-full border rounded px-3 py-2" value={form.industry} onChange={onChange}>
								<option value="">Select industry</option>
								{['Technology', 'Finance', 'Healthcare', 'Education', 'Retail', 'Other'].map((i) => (
									<option key={i} value={i}>
										{i}
									</option>
								))}
							</select>
						</div>
						<div>
							<label className="block text-sm font-medium text-gray-700 mb-1">Company Size</label>
							<select name="size" className="w-full border rounded px-3 py-2" value={form.size} onChange={onChange}>
								<option value="">Select size</option>
								{['1-10', '11-50', '51-200', '201-500', '500+'].map((s) => (
									<option key={s} value={s}>
										{s}
									</option>
								))}
							</select>
						</div>
					</div>
					<Input name="password" type="password" label="Password" value={form.password} onChange={onChange} required />
					<Input name="confirm" type="password" label="Confirm Password" value={form.confirm} onChange={onChange} required />
					<label className="flex items-center gap-2 text-sm">
						<input type="checkbox" name="terms" checked={form.terms} onChange={onChange} /> I agree to the terms and conditions
					</label>
					<Button type="submit" loading={loading} className="w-full" variant="secondary">
						Register
					</Button>
				</form>
				<p className="mt-4 text-sm text-center">
					Already have an account?{' '}
					<Link to="/company/login" className="text-blue-600 hover:underline">
						Company Login
					</Link>
				</p>
			</div>
		</div>
	);
}


